const estimated = 'Estimated 3-6 business days';
const ready = 'Most orders ready within 2 hours';
const vetRxSuffix = 'after vet approval';
const nearbyStores = 'Nearby stores with availability';

export const DELIVERY_MESSAGE = {
    estimated,
    ready,
    vetRxSuffix,
    nearbyStores,
};
